import { AthleteViews, CollegePlayer } from "rivals/shared/interfaces/Athlete";
import { Gallery } from "rivals/shared/interfaces/Content";
import { Prospect } from "rivals/shared/interfaces/Prospect";

export enum ShareMenuVariant {
  ATHLETE = "athlete",
  GALLERY = "gallery"
}
/**
 * activeAthleteView will be either `pv` which means user is currently viewing
 * the prospect profile and wants to share it, so the social post should preview
 * the prospect card, or it might be `cv` which means user is currently seeing the athlete profile
 * and wants to share it, so the expected social post should preview the athlete card.
 */
export interface Props {
  activeAthleteView?: AthleteViews;
  collegePlayer?: CollegePlayer;
  gallery?: Gallery;
  prospect?: Prospect;
  variant?: ShareMenuVariant;
}
